<!--
 * @Author: 仙道
 * @Date: 2023-02-10 22:40:31
 * @LastEditTime: 2023-03-08 22:28:03
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/dataScreen/index.vue
-->
<template>
  <div class="screen-container">
    <div class="box-container w-full h-full">
      <iframe :src="url" v-if="url" />
    </div>
    <a-button @click="logout" class="logout" icon="close" shape="circle" type="danger" />
    <!-- 添加AI助手按钮 -->
    <!-- <a-tooltip title="AI助手">
      <button
        :class="{ open: isPanelOpen }"
        @click="togglePanel"
        class="chatbot-button"
        v-if="!!localIframeSrc"
      >{{ isPanelOpen ? '×' : '?' }}</button>
    </a-tooltip>-->

    <a-tooltip title="AI助手">
      <button :class="{ open: isPanelOpen }" @click="togglePanel" class="chatbot-button" v-if="!!localIframeSrc">
        <img src="~@/assets/ai.svg" />
      </button>
    </a-tooltip>
    <!-- 添加AI助手面板 -->
    <div :class="{ open: isPanelOpen }" :style="{ height: panelHeight }" class="chatbot-panel">
      <div class="panel-header" v-show="showTitle">
        <span>{{ panelTitle }}</span>
        <div class="panel-header-buttons">
          <a-icon :type="isFullScreen ? 'shrink' : 'arrows-alt'" @click="toggleFullScreen" />
          <!-- <a-icon @click="newWindow" type="export" /> -->
          <a-icon @click="togglePanel" type="close" />
        </div>
      </div>
      <div class="panel-content">
        <!-- 这里可以添加AI助手的具体内容 -->
        <iframe :src="localIframeSrc" allow="microphone" frameborder="0" style="width: 100%; height: 100%"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { getAction } from '@/api/manage'

  export default {
    name: 'DataScreen',
    components: {},
    // 定义属性
    data () {
      return {
        url: '',
        isPanelOpen: false,
        showTitle: true,
        panelTitle: 'AI助手',
        isFullScreen: false,
        panelHeight: 'calc(100vh * 2 / 3)',
        defaultPanelHeight: 'calc(100vh * 2 / 3)',

        localIframeSrc: '',
        apiUrls: {
          categoryList: "/custom/category/list"
        },
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters([''])
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {
      getAction('/custom/category/rootList', {
        cusProp3: 'sys_ds_embed'
      }).then(res => {
        if (res.result.records.length > 0) {
          this.url = res.result.records[0]?.cusProp1
        }
      });

      this.getAiAgentProps();
    },
    //创建前设置
    beforeCreate () {
      document.querySelector('body').setAttribute('style', 'overflow-y:hidden;')
    },
    //销毁前清除
    beforeDestroy () {
      document.querySelector('body').removeAttribute('style')
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () { },
    // 方法集合
    methods: {
      ...mapActions(['Logout']),

      logout () {
        const that = this
        that.$confirm({
          title: '提示',
          content: '真的要注销登录吗 ?',
          onOk () {
            return that
              .Logout({})
              .then(() => {
                // update-begin author:wangshuai date:20200601 for: 退出登录跳转登录页面
                // that.$router.push({ path: '/user/login' });
                that.$router.push({ path: '/user/login', query: { redirect: that.$route.fullPath } })

                // window.location.reload()
                // update-end author:wangshuai date:20200601 for: 退出登录跳转登录页面
              })
              .catch(err => {
                that.$message.error({
                  title: '错误',
                  description: err.message
                })
              })
          },
          onCancel () { }
        })
      },

      getAiAgentProps () {
        getAction(this.apiUrls.categoryList, {
          cusProp1: 'aiAgent',
          enable: '1'
        }).then(res => {
          const props = res.result.records[0];
          if (props) {
            this.localIframeSrc = props.cusProp2;
          }
        })
      },
      // 新增方法，用于切换面板的显示隐藏
      togglePanel () {
        this.isPanelOpen = !this.isPanelOpen;
        this.panelHeight = this.defaultPanelHeight;
        this.isFullScreen = this.isPanelOpen && this.isFullScreen;
      },
      toggleFullScreen () {
        this.isFullScreen = !this.isFullScreen
        this.panelHeight = this.isFullScreen ? 'calc(100vh - 80px)' : this.defaultPanelHeight
      },
      newWindow () {
        if (this.localIframeSrc) {
          window.open(this.localIframeSrc, '_blank')
        }
      },
      preLogin(rec){
        if(!rec){
          return
        }
        localStorage.setItem('preLogin', rec.cusProp2);
      }
    }
  }
</script>

<style lang="less" scoped>
  .screen-container {
    padding: 0px;
    margin: 0px;

    height: 100%;
    position: relative;
    iframe {
      width: 100%;
      height: 100%;
    }
  }
  .logout {
    position: absolute;
    right: 20px;
    top: 10px;
  }

  /* 添加AI助手按钮样式 */
  .chatbot-button {
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: @primary-color;
    color: white;
    font-size: 24px;
    border: none;
    cursor: pointer;
    transition: transform 0.3s ease;
    z-index: 100;

    // 添加以下样式让图片居中
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .chatbot-button img {
    // 减小图标大小，可根据需要调整
    width: 24px;
    height: 24px;
    // 将 SVG 图标颜色修改为白色
    // filter: invert(100%) sepia(0%) saturate(7500%) hue-rotate(140deg) brightness(103%) contrast(103%);
  }
  .chatbot-button.open {
    transform: rotate(360deg);
  }
  .chatbot-panel {
    position: fixed;
    bottom: 80px;
    right: 20px;
    width: 600px;
    background-color: white;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    opacity: 0;
    visibility: hidden;
    transform: translateY(20px);
    transition: opacity 0.3s ease, visibility 0.3s ease, transform 0.3s ease;
    z-index: 99;
    display: flex;
    flex-direction: column;
  }
  .chatbot-panel.open {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }
  .panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 16px;
    border-bottom: 1px solid #ccc;
    font-size: 20px;
    font-weight: bold;
  }
  .panel-header-buttons {
    display: flex;
    gap: 20px;
    font-size: 16px;
  }
  .panel-content {
    flex: 1;
    padding: 10px;
    overflow-y: auto;
  }
</style>
